import { useEffect, useState } from 'react'
import { api } from '@/util/api'
import { useAuth } from '@/state/AuthContext'
import type { OrgResource } from '@/types/admin'

export function useAdminOrganizations() {
  const { user, organization } = useAuth()
  const [organizations, setOrganizations] = useState<OrgResource[]>([])
  const isSuperadmin = user?.attributes?.role === 'superadmin'

  useEffect(() => {
    if (!isSuperadmin) {
      setOrganizations(organization ? [organization as OrgResource] : [])
      return
    }

    api.getAdminOrganizations()
      .then((res) => setOrganizations(res.data))
      .catch(() => {})
  }, [isSuperadmin, organization])

  return { organizations, isSuperadmin }
}
